// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SlimSelectController from './slim_select_controller'
application.register('slim-select', SlimSelectController)

import RichtextController from "./richtext_controller";
application.register('richtext', RichtextController)

import ScrollProgress from '@stimulus-components/scroll-progress'
application.register('scroll-progress', ScrollProgress)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)
